import { defineComponent as a, createBlock as n, openBlock as f, resolveDynamicComponent as p, mergeProps as u, unref as s, withCtx as i, renderSlot as m } from "vue";
import { useOUIAProps as d } from "../../helpers/ouia.js";
const B = /* @__PURE__ */ a({
  name: "PfTabButton",
  __name: "TabButton",
  props: {
    href: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(t) {
    const o = t, r = d({ id: o.ouiaId, safe: o.ouiaSafe });
    return (e, l) => (f(), n(p(e.href ? "a" : "button"), u(s(r), {
      type: e.href ? void 0 : "button",
      href: e.href
    }), {
      default: i(() => [
        m(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["type", "href"]));
  }
});
export {
  B as default
};
